/**
 * Created by nijin on 12/12/16.
 */
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { AuthGuard } from "./auth/auth-guard.service";
import { ProfileResolver } from "./auth/profile-resolver";
import { SiteNotAvailableComponent } from "./site/site-not-available.component";
import { ServerStatusGuard } from "./auth/server-status.guard";
import { SiteGuard } from "./auth/site-guard";

const routes: Routes = [
  {
    path: "",
    loadChildren: "app/site/site.module#SiteModule",
    data: { preload: true },
    canActivate: [SiteGuard],
  },
  {
    path: "register",
    loadChildren: "app/registration/registration.module#RegistrationModule",
    canLoad: [AuthGuard],
    data: { preload: true },
  },
  {
    path: "intro",
    loadChildren: "app/intro-wizard/intro-wizard.module#IntroWizardModule",
    data: { preload: true },
    canActivate: [ProfileResolver],
  },
  {
    path: "things",
    loadChildren: "app/things/things.module#ThingsModule",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { preload: true },
  },
  {
    path: "schema",
    loadChildren: "app/schema/schema.module#SchemaModule",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { preload: true },
  },
  {
    path: "rules",
    loadChildren: "app/rules/rules.module#RulesModule",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { preload: true },
  },
  {
    path: "accounts",
    loadChildren: "app/accounts/accounts.module#AccountModule",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { preload: true },
  },
  {
    path: "team",
    loadChildren: "app/team/team.module#TeamModule",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: { preload: true },
  },
  {
    path: "server-not-available",
    component: SiteNotAvailableComponent,
    canActivate: [ServerStatusGuard],
  },
  { path: "**", redirectTo: "things" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  declarations: [],
  providers: [],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts